// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import { isTouchDevice } from 'fg-frontend/plugins/utils';

export default class WebLayout extends WebComponent {

  constructor(props) {
    super(props);
  }

  didMount() {
    const bodyEl = this.element;

    // Třída na body když je display dotykový
    if (isTouchDevice()) bodyEl.classList.add('touch-device');
  }
}



// WEBPACK FOOTER //
// ./config/module-publish/resources-cvrez/js/components/WebLayout.js